import React from "react";

const RouteContext = React.createContext({
  name: "index",
});

export default RouteContext;
